module.exports = __webpack_public_path__ + "static/media/PSOJ-high-res-logo.def3e92b.png";